export default "__VITE_ASSET__1d012087__"